<template>
  <div
    id="accomplishments-candidate"
    class="create-profile-step-container"
  >
    <step-title
      :title="title"
      :subtitle="subtitle"
      :icon="icon"
      :help-text="helpText"
    />
    <section class="section no-pad-top no-pad-left-right">
      <div
        v-for="(accomplishment, index) in accomplishments"
        :key="accomplishment.key"
      >
        <p
          class="is-size-7 has-text-grey has-text-right character-count"
        >
          {{ getRemainingCharacters(accomplishment, profileValidationConstants.ACCOMPLISHMENT_CANDIDATE_MAX ) }} Characters Left
        </p>
        <div class="field">
          <div
            class="remove"
            @click="removeAccomplishment(index)"
          >
            <span>
              <i class="fas fa-times-circle" />
            </span>
          </div>
          <textarea
            v-model="accomplishments[index]"
            v-validate="'required'"
            class="textarea"
            placeholder="e.g. Grew company revenues by 50%"
            maxlength="300"
            :name="`accomplishment ${index + 1}`"
            @keyup="updateAccomplishments()"
          />
          <p
            v-show="errors.has(`accomplishment ${index + 1}`)"
            class="help is-danger"
          >
            {{ errors.first(`accomplishment ${index + 1}`) }}
          </p>
        </div>
      </div>
      <div>
        <div
          v-if="accomplishments.length < 5 && accomplishments[accomplishments.length - 1] !== ''"
          class="is-inline-block add-another has-text-primary"
          @click="addAccomplishment()"
        >
          <i class="fas fa-plus" />
          <small
            v-if="accomplishments.length > 0"
            class="has-text-weight-bold"
          >&nbsp;Add Another Accomplishment</small>
          <small
            v-else
            class="has-text-weight-bold"
          >&nbsp;Add an Accomplishment</small>
        </div>
        <div
          v-else-if="accomplishments.length >= 5"
          class="is-inline-block add-another"
        >
          <small class="has-text-weight-bold has-text-grey">Reached maximum of 5 accomplishments.</small>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import StepTitle from './StepTitle';
import { profileValidationConstants } from '@/helpers/constants';

export default {
  name: 'AccomplishmentsCandidate',
  components: {
    StepTitle
  },
  data () {
    return {
      title: 'Accomplishments',
      subtitle: 'Tell employers why you stand out',
      icon: 'fa-medal',
      helpText: '(Up to 5)',
      accomplishments: [],
      profileValidationConstants
    };
  },
  computed: {
    isFormValid () {
      return (
        this.accomplishments.length > 0
        && Object.keys(this.fields).every(key => this.fields[key].valid)
      );
    }
  },
  created () {
    this.accomplishments = this.$store.state.user.profile.accomplishments;
  },
  methods: {
    addAccomplishment () {
      this.accomplishments.push('');
      this.checkForm();
      this.updateAccomplishments();
    },
    updateAccomplishments () {
      this.checkForm();
      this.$store.commit(
        'EDIT_CANDIDATE_ACCOMPLISHMENTS',
        this.accomplishments
      );
    },
    removeAccomplishment (index) {
      if (index > -1) {
        this.accomplishments.splice(index, 1);
      }
      this.checkForm();
      this.updateAccomplishments();
    },
    checkForm () {
      setTimeout(() => {
        this.$emit('checkForm', this.isFormValid);
      }, 50);
    },
    /**
     * @function getRemainingCharacters
     * Gets the remaining characters available in an input field, given the current string and a Max value
     * @param string The input string that we want to calculate remaining available characters for
     * @param maxCharacters Max value allowed in field
     * @returns {Number}
     */
    getRemainingCharacters (string, maxCharacters) {
      return maxCharacters - string.length;
    }
  }
};
</script>

<style lang="scss" scoped>
.character-count {
  padding-right: 1rem;
}

.degree-container {
  box-shadow: 0 2px 6px 0 rgba(77, 101, 117, 0.25);
  margin-bottom: 1rem;
}

.card {
  border-radius: 4px;
}

.remove {
  position: relative;
  width: 100%;
  span {
    position: absolute;
    right: -9px;
    top: -12px;
    z-index: 1;
    padding: 0 4px;
    background: white;
    cursor: pointer;
  }
}
.textarea {
  margin-bottom: 1rem;
}

.add-another {
  cursor: pointer;
}
</style>
